<template>
  <section v-if="estateList && estateList.length" class="estate-swiper" :class="classes">
    <div class="estate-swiper__container">
      <div class="estate-swiper__head">
        <app-title>
          {{ title }}
        </app-title>

        <AppToggle v-if="query.showMap === false && title === 'Вторичная недвижимость'"
          class="resale-estate__toggle-map"
          label="Показать на карте"
          @change="toggleMap" 
          like-icon="location"  
        />
      </div>

      <swiper
        class="estate-swiper__swiper"
        :modules="modules"
        :breakpoints="{
          320: { slidesPerView: 1 },
          640: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
          1280: { slidesPerView: 4 },
        }"
        :space-between="8"
        :speed="800"
        :navigation="{ nextEl: '.estate-swiper__nav_next', prevEl: '.estate-swiper__nav_prev' }"
      >
        <swiper-slide v-for="(card, index) in estateList" :key="index" class="estate-swiper__slide">
          <EstateCard v-if="isZhk == 0" :is-small="true" :card="card" />
          <EstateNewCard v-else :is-small="true" :card="card" />
        </swiper-slide>

        <div class="estate-swiper__nav-swiper">
          <div class="estate-swiper__nav_prev">
            <app-svg id="arrow-left" width="15" height="15" />
          </div>
          <div class="estate-swiper__nav_next">
            <app-svg id="arrow-right" width="15" height="15" />
          </div>
        </div>
      </swiper>

      <AppButton class="estate-swiper__view-all" :to="isZhk == 0 ? '/resale-estate' : '/new-estate'">
        <template v-if="isZhk == 0">Каталог</template>
        <template v-else>Все новостройки</template>
      </AppButton>
    </div>
  </section>
</template>

<script>
import { mapState } from "pinia";
import { useFilterStore } from "@/store/filters/filterStore.js";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation, Pagination } from "swiper";
import EstateCard from "@/components/EstateCard.vue";
import EstateNewCard from "@/components/EstateNewCard.vue";
import AppButton from "./ui/AppButton.vue";
import AppToggle from "./ui/AppToggle.vue";

export default {
  name: "EstateDetailSwiper",
  components: { Swiper, SwiperSlide, EstateCard, EstateNewCard, AppButton, AppToggle },

  props: {
    title: {
      type: String,
      default: () => "",
    },
    secondary: {
      type: Boolean,
      default: false,
    },
    grey: {
      type: Boolean,
      default: false,
    },
    estateList: {
      type: Array,
      default: () => [],
    },
    isZhk: {
      type: Number,
      default: () => 0,
    },
    recently: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      modules: [Navigation, Pagination],
    };
  },

  computed: {
    classes() {
      return {
        _secondary: this.secondary,
        _grey: this.grey,
      };
    },
    ...mapState(useFilterStore, ["query"]),
  },

  methods: {
    toggleMap(e) {
      this.emitter.emit("toggle-map", e);
    }
  }
};
</script>

<style lang="scss" scoped>
.estate-swiper {
  $this: &;

  padding: 64px 0;
  // margin: 0 -56px;
  background-color: $white;
  position: relative;

  @include laptop {
    margin: 0;
  }

  @include tablet {
    padding: 48px 0;
  }

  &._secondary {
    background-color: transparent;
  }

  &._grey {
    background-color: #f6f6f6;
    border-bottom-right-radius: 240px;

    @include phone {
      border-bottom-right-radius: 70px;
    }
  }

  &__container {
    @extend %container;
    position: relative;
  }

  &__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;
  }

  &__nav-swiper {
    display: flex;
    justify-content: center;
    margin-top: 60px;
    flex: none;
    display: flex;
    gap: 10px;
    color: $color_primary;

    .estate-swiper__nav_prev,
    .estate-swiper__nav_next {
      cursor: pointer;
      width: 46px;
      height: 46px;
      border-radius: 50%;
      border: 1px solid $color_orange-50;
      display: flex;
      align-items: center;
      justify-content: center;

      &.swiper-button-disabled {
        color: $color_grey-15;
        border-color: $color_grey-15;
      }

      flex: none;
      transition: color 0.3s ease, border 0.3s ease;

      @include phone {
        width: 32px;
        height: 32px;

        svg {
          width: 12px;
          height: 12px;
        }
      }
    }

    @include tablet {
      // display: none;
      justify-content: space-between;
      margin-top: 28px;
    }
  }

  // &__swiper {
  //   overflow: visible;
  //   margin: 0;

  //   @include desktop {
  //     margin: 0;
  //   }

  //   @include phone {
  //     margin: 0;
  //   }
  // }

  &__slide {
    height: auto;
    padding: 0;
    opacity: 0;
    transition: opacity 0.25s 0.5s ease;

    &.swiper-slide-active {
      opacity: 1;
      transition: opacity 0.25s ease;

      & + #{$this}__slide {
        opacity: 1;
        transition: opacity 0.25s ease;

        @include phone {
          opacity: 0;
        }
      }

      & + #{$this}__slide + #{$this}__slide {
        opacity: 1;
        transition: opacity 0.25s ease;

        @include tablet {
          opacity: 0;
        }
      }

      & + #{$this}__slide + #{$this}__slide + #{$this}__slide {
        opacity: 1;
        transition: opacity 0.25s ease;

        @include tablet {
          opacity: 0;
        }
      }
    }

    @include desktop {
      padding: 0 10px;
    }

    @include phone {
      padding: 0;
    }
  }

  // &__pagination {
  //   padding: 12px 0;

  //   @media (min-width: 640px) {
  //     display: none;
  //   }
  // }

  &__view-all {
    position: absolute;
    // bottom: 64px;
    bottom: 0;
    left: 75.5%;
    padding: 16px 60px;
    // left: calc(((25vw + 16px) * 3) - 56px);
    z-index: 1;

    @include tablet {
      height: 32px;
      font-size: 12px;
      line-height: 120%;
      // bottom: 48px;
      left: 50%;
      transform: translateX(-50%);
      padding: 8px 20px;
    }
  }
}
</style>
